import { Component, OnInit } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import { VehiclesService } from '@app/shared/services/vehicles.service';
import { SessionService } from '@app/shared/services/session.service';
import { ExcelService } from '@app/shared/services/excel.service';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs/internal/operators';
import { Subject } from 'rxjs';
import { AlertService } from '@app/shared/services/alert.service';

@Component({
    selector: 'app-vehicle-list',
    templateUrl: './vehicle-list.component.html',
    styleUrls: ['./vehicle-list.component.scss']
})
export class VehicleListComponent implements OnInit {

    public vehicles: Array<any> = [];
    public maxPages: number = 1;
    public search: string = '';
    public searchChanged: Subject<string> = new Subject<string>();
    public currentPage: number = 1;
    public loadingStatus: boolean = true;
    public noResult: boolean = false;
    public excelLoading: boolean = false;
    public disabledVehicul: boolean = true;

    public status: number = 0;
    public filtre: number = 1;

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private vehicleService: VehiclesService,
        public session: SessionService,
        private excelService: ExcelService,
        private router: Router,
        private alertService: AlertService
    ) {
        this.searchChanged
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe(model => {
                this.filtre = 0;
                this.search = model;
                this.currentPage = 1;
                sessionStorage.setItem('VehicleFilterSearch', this.search);
                this.updateVehicles();
            });
    }

    retrieveFilters() {
        this.search = ('VehicleFilterSearch' in sessionStorage) ? sessionStorage.getItem('VehicleFilterSearch') : this.search;
    }

    ngOnInit() {
        this.titleService.setTitle(`Liste des véhicules / VOP`);
        this.menu.setMenuState('ressource', 'vehicle', '');
        this.retrieveFilters();
        if ('VehicleList' in sessionStorage) {
            this.filterVehicles(JSON.parse(sessionStorage.getItem('VehicleList')))
            // this.vehicles = JSON.parse(sessionStorage.getItem('VehicleList'));
            this.maxPages = parseInt(sessionStorage.getItem('VehicleListMaxPages'), 10);
            this.currentPage = parseInt(sessionStorage.getItem('VehicleListCurrentPage'), 10);
            this.loadingStatus = false;
        } else {
            this.updateVehicles();
        }
    }

    onSearchChange(search): void {
        this.searchChanged.next(search);
    }

    goToStationList(): void {
        this.router.navigate(['ressource/station/list']);
    }

    checkDisabledVehicle(vehicles): void {
        if (vehicles.filter(vehicle => vehicle.idDisabledVehicle != 0).length == 0) {
            this.disabledVehicul = false
        }
    }

    filterVehicles(vehicles): any {
        this.checkDisabledVehicle(vehicles)

        if (this.filtre == 1) {
            this.vehicles = vehicles.filter(vehicle => vehicle.idDisabledVehicle == 0);
        }
        else if (this.filtre == 2) {
            this.vehicles = vehicles.filter(vehicle => vehicle.idDisabledVehicle != 0);
        }
        else {
            this.vehicles = vehicles;
        }
    }

    setVehicles(res) {
        this.filterVehicles(res)

        sessionStorage.setItem('VehicleList', JSON.stringify(res));
        sessionStorage.setItem('VehicleListMaxPages', this.maxPages.toString());
        sessionStorage.setItem('VehicleListCurrentPage', this.currentPage.toString());
    }

    updateVehicles() {
        this.loadingStatus = true;
        this.currentPage = 1;
        this.vehicleService.updateVehicleCount(this.search).then(() => {
            this.maxPages = this.vehicleService.maxPages;
        });
        this.vehicleService.updateVehicles(this.currentPage, this.search).then((res) => {
            const actualDate = new Date();
            console.log(res)
            res.forEach(vehicle => {
                const date = new Date(vehicle.ISOLastConnection);
                console.log(date)
                if (actualDate.getTime() - date.getTime() >= 6 * 60 * 60 * 1000) {
                    //derniere connection plus de 6h
                    vehicle.connection = 0;
                }
                else if (actualDate.getTime() - date.getTime() >= 3 * 60 * 60 * 1000) {
                    //derniere connection moins de 6h
                    vehicle.connection = 1;
                }
                else {
                    //derniere connection moins de 3h
                    vehicle.connection = 2;
                }
            })

            this.loadingStatus = false;
            if (this.vehicleService.vehicles.length === 0) {
                this.noResult = true;
            } else {
                this.noResult = false;
                this.setVehicles(res);
            }
        });
    }

    getLastUpdate(vehicle): string {
        const date = new Date(vehicle.ISOLastConnection);
        console.log(date)
        return "Der. connexion : " + date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    nextPage(): any {
        this.loadingStatus = true;
        this.vehicleService.updateVehicleCount(this.search).then(() => {
            this.maxPages = this.vehicleService.maxPages;
            if (this.currentPage < this.vehicleService.maxPages) {
                this.currentPage += 1;
                this.vehicleService.updateVehicles(this.currentPage, this.search).then((res) => {
                    this.loadingStatus = false;
                    if (this.vehicleService.vehicles.length === 0) {
                        this.noResult = true;
                    } else {
                        this.noResult = false;
                        this.setVehicles(res);
                    }
                });
            }
        });
    }

    goPage(page): any {
        this.loadingStatus = true;
        this.vehicleService.updateVehicleCount(this.search).then(() => {
            this.maxPages = this.vehicleService.maxPages;
            this.currentPage = page;
            this.vehicleService.updateVehicles(this.currentPage, this.search).then((res) => {
                this.loadingStatus = false;
                if (this.vehicleService.vehicles.length === 0) {
                    this.noResult = true;
                } else {
                    this.noResult = false;
                    this.setVehicles(res);
                }
            });
        });
    }

    prevPage(): any {
        this.loadingStatus = true;
        this.vehicleService.updateVehicleCount(this.search).then(() => {
            this.maxPages = this.vehicleService.maxPages;
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.vehicleService.updateVehicles(this.currentPage, this.search).then((res) => {
                    this.loadingStatus = false;
                    if (this.vehicleService.vehicles.length === 0) {
                        this.noResult = true;
                    } else {
                        this.noResult = false;
                        this.setVehicles(res);
                    }
                });
            }
        });
    }

    exportDataAsXLSX(): any {
        let datas = [];
        let cols = this.excelService.initCols(["Immatriculation", "Marque", "Modèle", "Kilométrage",
            "Catégorie du véhicule", "Description", "Statut"]);

        this.excelLoading = true;
        this.vehicleService.updateVehicleCount(this.search || '').then(async () => {
            this.maxPages = Math.max(this.vehicleService.maxPages, 1);
            for (let i = 1; i <= this.maxPages; i++) {
                let results = await this.vehicleService.updateVehicles(i, this.search || '');

                if (results.length == 0) {
                    this.excelLoading = false;
                    return this.alertService.alert("Aucune donnée à exporter");
                }

                results.forEach((result) => {
                    let data = {
                        "Immatriculation": result.name,
                        "Marque": result.brand,
                        "Modèle": result.model,
                        "Kilométrage": result.vehicleCounterKm,
                        "Catégorie du véhicule": result.vehicleCategeory,
                        "Description": result.vehicleDetails,
                        "Statut": (result.idDisabledVehicle > 0) ? 'Inactif' : 'Actif'
                    };

                    Object.values(data).forEach((value, index) => {
                        if (typeof value === 'string') {
                            cols[index].wch = Math.max(value.length, cols[index].wch);
                        }
                    });
                    datas.push(data);
                });
            }
            cols = this.excelService.extendCols(cols);
            this.excelService.exportExcel(datas, "vop-vehicles", cols);
            this.excelLoading = false;
        });
    }

    changeFiltre(filtre): void {
        this.filtre = filtre;
        this.updateVehicles()
    }
}
